import { render, staticRenderFns } from "./openTable.vue?vue&type=template&id=e5cd68b2&scoped=true&"
import script from "./openTable.vue?vue&type=script&lang=js&"
export * from "./openTable.vue?vue&type=script&lang=js&"
import style0 from "./openTable.vue?vue&type=style&index=0&id=e5cd68b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd68b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5cd68b2')) {
      api.createRecord('e5cd68b2', component.options)
    } else {
      api.reload('e5cd68b2', component.options)
    }
    module.hot.accept("./openTable.vue?vue&type=template&id=e5cd68b2&scoped=true&", function () {
      api.rerender('e5cd68b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/components/openTable.vue"
export default component.exports